import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
// BASE ------------------------------------------------------------------------
import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { getSpendingAccounts } from 'app-components/flux/accounts/accountsSelectors';
// import { authSelectors } from 'app-components/flux/auth';
import { tracker } from 'app-components/utils/core';
import { constructPredefinedInterval } from 'app-components/utils/date';
// SELECTORS, ACTIONS, UTILS ------------------------------------------------------------------------
import { getConversationalCategoryData } from 'data/conversationalReports/selectors';
// import { profileSelectors } from 'app-components/flux/profile';

// MUI COMPONENTS ------------------------------------------------------------------------

// CUSTOM COMPONENTS ------------------------------------------------------------------------
// import Dump from 'components/Dump';

// CUSTOM COMPONENTS (path relative) ------------------------------------------------------------------------
import MainChatPage from './AiAssistant/MainChatPage';

import { entitlementsSelectors } from 'app-components/flux/entitlements';
// PATH RELATIVE  ------------------------------------------------------------------------
import { aiExpertsConfig } from './aiConfig';

// STYLES ------------------------------------------------------------------------

//------------------------------------------------------------------------
// ChatReport Component
//------------------------------------------------------------------------
const ChatReport = (props) => {
  const { title, visible, onClose } = props;

  const isBusiness = useSelector(entitlementsSelectors.getBusinessEnabled);

  const expertName = isBusiness ? 'smallBusiness' : 'personalFinance';
  const spendingAccounts = useSelector((state) => getSpendingAccounts(state), shallowEqual);
  // const profile = useSelector(profileSelectors.getProfile);
  const filterObject = useMemo(() => ({ accounts: spendingAccounts.keySeq() }), [spendingAccounts]);
  const dateRange = useMemo(() => constructPredefinedInterval({ value: 'LAST_12_MONTHS' }, DateTime.local()), []);

  const contextData = useSelector(
    (state) => getConversationalCategoryData(state, { filterObject, dateRange }),
    shallowEqual,
  );

  /*
   * Render
   */
  return (
    <MainChatPage
      context={isBusiness ? contextData : contextData}
      title={title || `I am here to provide you focused assistance with ${aiExpertsConfig[expertName].label}!`}
      expertName={expertName}
      visible={visible}
      onClose={onClose}
      tracker={tracker}
    />
  );
};

ChatReport.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ChatReport;
